import React from "react";
import CustomPieChart from "./CustomHorizontalBarChart";

const BusinessTypeSection = ({ currentData }) => {
  return (
    <div>
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">By Business Entity</h3>
      <CustomPieChart
        data={currentData?.businessTypeData || []}
        otherBreakdown={currentData?.otherBusinessTypeData || []}
      />
    </div>
  );
};

export default BusinessTypeSection;